<template>
  <div >
    <!-- 头部导航 -->
    <!-- <van-nav-bar :title="activeTitle"/> -->
    <!-- 给router-view外面, 套一个div.home_container, 并且防止二级页面内容, 被底部导航挡住 -->
    <div class="home_container" >
      <!-- 二级路由页面 -->

      <router-view></router-view>
      <bottom-marker></bottom-marker>
    </div>
    <!-- 底部导航 -->
    <van-tabbar v-model="active" route>
      <van-tabbar-item name="首页" icon="wap-home" to="/layout/home"
        >首页</van-tabbar-item>
      <van-tabbar-item name="数据" icon="bars" to="/layout/field"
        >数据</van-tabbar-item>
      <van-tabbar-item name="我的" icon="manager" to="/layout/user"
        >我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
// import BottomMarker from '@/components/BottomMarker.vue'
export default {
  // components: { BottomMarker },
  name: 'Layout',
  data() {
    return {
      active: 0,
      activeTitle: this.$route.meta.title
    }
  },
  // 侦听路由改变，修改activeTitle的值
  watch: {
    $route() {
      // 直接侦听组件对象身上的任意属性
      // 路由改变时
      this.activeTitle = this.$route.meta.title
    }
  },
  methods:{
  }
}
</script>

<style lang="less" scoped>
/* 内容底部内边距(把内容往上挤压, 防止内部被底部导航挡住) */
.home_container {
  min-height: 600px;
  padding-bottom: 60px;
  background: white;
}
/* 底部导航上边框 */
.van-tabbar {
  border-top: 1px solid #f8f8f8;
  padding-bottom: 10px;
}
</style>
